module.exports = __webpack_public_path__ + "static/media/Guide_Conecta_Atacado.95d80131.pdf";